import { render, staticRenderFns } from "./ProlongedSickLeaveModal.vue?vue&type=template&id=cd761656"
import script from "./ProlongedSickLeaveModal.vue?vue&type=script&lang=js"
export * from "./ProlongedSickLeaveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports